import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {SysFunction} from "../../../model/sys/SysFunction";
import {PermissionToolkitService} from "../../../services/permission-toolkit.service";

@Component({
  selector: 'pi-navigation-menu',
  templateUrl: './pi-navigation-menu.component.html',
  styleUrls: ['./pi-navigation-menu.component.css']
})
export class PiNavigationMenuComponent implements OnInit, OnChanges {
  @Input() moduleFunction;
  @Input() isCollapsed = false;
  @Input() forceReload = false;
  @Input() theme: 'light' | 'dark' = 'light';
  menuData: SysFunction[];

  constructor(
    public router: Router,
    private permissionToolkitService: PermissionToolkitService
  ) {
    if (this.forceReload) {
      // 让模块切换的时候重载页面
      // override the route reuse strategy
      this.router.routeReuseStrategy.shouldReuseRoute = function() {
        return false;
      }

      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationEnd) {
          // trick the Router into believing it's last link wasn't previously loaded
          this.router.navigated = false;
          // if you need to scroll back to top, here is the right place
          window.scrollTo(0, 0);
        }
      });
    }

  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.moduleFunction) {
      this.loadMenuData();
    }
  }

  loadMenuData() {
    this.permissionToolkitService.clearData();
    const result = this.permissionToolkitService.getChildrenPages(this.moduleFunction);
    if (result) {
      const privilegeList = this.permissionToolkitService.getUserPrivilegeList();
      const data= result.childFunctions.filter(i => i['displayed'] &&
        (privilegeList && privilegeList.indexOf(i['id']) > -1));
      data.sort((a, b) => a.displayOrder - b.displayOrder);
      this.processFunctionOrders(data);
      this.menuData = data;
    }
  }

  processFunctionOrders(functionDatas) {
    if (functionDatas) {
      functionDatas.sort((a, b) => a.displayOrder - b.displayOrder);
      functionDatas.forEach(f => {
        this.processFunctionOrders(f.childFunctions);
      })
    }
  }

  // loadMenuData() {
  //   this.permissionToolkitService.clearData();
  //   const result = this.permissionToolkitService.getChildrenPages(this.moduleFunction);
  //   if (result) {
  //     const privilegeList = this.permissionToolkitService.getUserPrivilegeList();
  //     const data = this.processFunctionOrders(result, privilegeList);
  //     this.menuData = data;
  //   }
  // }
  //
  // processFunctionOrders(functionData, privilegeList) {
  //   const dataList = functionData.childFunctions.filter(i => i['displayed'] &&
  //     (privilegeList && privilegeList.indexOf(i['id']) > -1));
  //   if (dataList) {
  //     dataList.childFunctions.sort((a, b) => a.displayOrder - b.displayOrder);
  //     dataList.childFunctions.forEach(f => {
  //       f = this.processFunctionOrders(f.childFunctions, privilegeList);
  //     });
  //   }
  //   return dataList;
  // }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

  activeCondition(routename: Array<string>): boolean {
    return routename.includes(this.router.url);
  }

}
